import style from '@root-gipro/modules/AdminPanel/components/AdminObjectsAnalog/components/modals/AdminAddObjectAnalog/AdminAddObjectAnalog.module.scss';

import { Fade, Modal, Theme, createStyles, makeStyles, TextField } from '@material-ui/core'
import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IState } from '@root-gipro/store/interfaces'
import {
  getAdminObjectsAnalog,
} from '@root-gipro/modules/AdminPanel/store/actions/actionAdminObjectsAnalog'
import Loader from '@root-gipro/shared/Loader/Loader'
import { postProjectRPC, setProjectAddModalOA } from '@root-gipro/modules/userProjects/store/actions'
import OASelect from '@root-gipro/modules/userProjects/components/Project/ProjectRpc/OASelect'

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			overflow: 'auto',
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
		},
	})
)

const ProjectAddObjectAnalog: FC<{
  projectId: any
}> = ({
  projectId
}) => {
  
	const classes = useStyles();
	const dispatch = useDispatch();

  const {
    addOAModal
  } = useSelector((state: IState) => state.userProjects.rpc);

  const {
    isObjectsAnalogLoading,
    objectsAnalog,
  } = useSelector((state: IState) => state.adminPanel.objectsAnalogCommon);
  
  const onCloseHandler = () => {
    dispatch(setProjectAddModalOA(null));
  };
  
  const onChangeSelectOAHandler = (oaId: any) => {
    if(oaId) {
      dispatch(setProjectAddModalOA({
        inputs: {
          oaId,
        }
      }));
    }
  };
  
  const onAddHandler = () => {
    if(addOAModal.inputs?.oaId && projectId) {
      dispatch(postProjectRPC({
        projectId,
        oaId: addOAModal.inputs.oaId
      }));
    }
  };

  useEffect(() => {
    if(addOAModal?.isOpen) {
      dispatch(getAdminObjectsAnalog({}));
    }
  }, [addOAModal?.isOpen])

  return (
		<Modal
			open={addOAModal?.isOpen ?? false}
			onClose={onCloseHandler}
			aria-labelledby='simple-modal-title'
			aria-describedby='simple-modal-description'
			className={classes.modal}
			closeAfterTransition
		>
			<Fade in={addOAModal?.isOpen}>
				<form
          className={style.adminAddObjectAnalog}
					noValidate
					autoComplete='off'
					style={{ background: 'white', padding: '32px', maxWidth: 550, width: '100%', height: 300 }}
				>
					<div style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100%', position: 'relative' }}>

            <h3>Выберите объект-аналог</h3>

            <div style={{ height: '100%' }}>
              {isObjectsAnalogLoading && (
                <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', height: '100%', backgroundColor: '#fff', zIndex: 100 }}>
                  <Loader />
                </div>
              )}
              
              <OASelect 
                objectsAnalog={objectsAnalog}
                setOA={onChangeSelectOAHandler}
              />
            </div>
            
            <div className={style.adminAddObjectAnalog__btns}>
              <div className={
                style.adminAddObjectAnalog__btnWr +
                (!addOAModal.inputs?.oaId ? ` ${style.adminAddObjectAnalog__btnWrDisabled}` : '')
              }>
                <button
                  className={style.adminAddObjectAnalog__btn}
                  onClick={onAddHandler}
                  type='button'
                >
                  Добавить
                  <span
                    className={
                      style.adminAddObjectAnalog__preloaderWr +
                      (addOAModal?.isAdding ? ` ${style.adminAddObjectAnalog__preloaderWrShow}` : '')
                    }
                  >
                  
								<span className={style.adminAddObjectAnalog__preloader}>
									<Loader />
								</span>
							</span>
                </button>
              </div>
            </div>
          </div>
				</form>
			</Fade>
		</Modal>
	)
}

export default ProjectAddObjectAnalog;
